import { render, staticRenderFns } from "./SelecionarVariacao.vue?vue&type=template&id=dd954b3a&scoped=true&"
import script from "./SelecionarVariacao.vue?vue&type=script&lang=js&"
export * from "./SelecionarVariacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd954b3a",
  null
  
)

export default component.exports